"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconLocationFill', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8.00006 1C5.82819 1 3.00006 2.69257 3.00006 5.77526C3.00006 6.77526 3.00006 8.34479 7.18421 14.5634C7.5741 15.1429 8.42602 15.1429 8.81591 14.5634C13.0001 8.34479 13.0001 6.77526 13.0001 5.77526C13.0001 2.69124 10.1719 1 8.00006 1ZM8.00006 8C9.10463 8 10.0001 7.10457 10.0001 6C10.0001 4.89543 9.10463 4 8.00006 4C6.89549 4 6.00006 4.89543 6.00006 6C6.00006 7.10457 6.89549 8 8.00006 8Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M10 2C7.39375 2 4 4.00287 4 7.65073C4 8.84683 4 10.9916 9.18542 18.5751C9.57649 19.147 10.4235 19.147 10.8146 18.5751C16 10.9916 16 8.84683 16 7.65073C16 4.0013 12.6062 2 10 2ZM10 10C11.1046 10 12 9.10457 12 8C12 6.89543 11.1046 6 10 6C8.89543 6 8 6.89543 8 8C8 9.10457 8.89543 10 10 10Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M13 3C9.95938 3 6 5.30886 6 9.51403C6 10.9033 6 13.6683 12.1883 22.5942C12.5804 23.1597 13.4196 23.1597 13.8117 22.5942C20 13.6683 20 10.9033 20 9.51403C20 5.30705 16.0406 3 13 3ZM13 13C14.6569 13 16 11.6569 16 10C16 8.34315 14.6569 7 13 7C11.3431 7 10 8.34315 10 10C10 11.6569 11.3431 13 13 13Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M16 3C11.6562 3 6 6.19 6 12C6 13.9449 6 17.7811 15.1961 30.5027C15.5914 31.0496 16.4086 31.0496 16.8039 30.5027C26 17.7811 26 13.9449 26 12C26 6.1875 20.3438 3 16 3ZM16 17C18.2091 17 20 15.2091 20 13C20 10.7909 18.2091 9 16 9C13.7909 9 12 10.7909 12 13C12 15.2091 13.7909 17 16 17Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;